import { getCurrentLanguageAndInstanceCode } from "services/instances"

const [lang, instance] = getCurrentLanguageAndInstanceCode()

export const redirectToNextStep = (navigate) => navigate(`../${lang}-${instance}/claims/step-5`, { replace: true })
